import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import styles from './ErrorPanel.css';

const ErrorPanel = ({ error }) =>
  <div className={styles.container}>
    <h1>Oops something went wrong.</h1>
    <h2 className={styles.errorMessage}>
      {error.message}
    </h2>
    <Button
      icon="refresh"
      onClick={() => window.location.reload(true)}
      raised
      primary
    >
      Reload
    </Button>
  </div>;

export default ErrorPanel;



// WEBPACK FOOTER //
// ./src/general-components/ErrorPanel.js